
import { computed, defineComponent, PropType, toRefs, provide, readonly, reactive, inject } from "vue";
import UfTreeNode from "./HouseTreeNode.vue";

export interface HouseTreeNode {
  id: string;
  lists: HouseTreeNode[];
  is_house: string;
  pid: string;
  place: string;
  ppath: string;
}

export interface HouseTreeType {
  checkedList: HouseTreeNode[];
  getCurrentNode: () => HouseTreeNode | HouseTreeNode[];
  updateChecked: (data: any) => any;
}

export default defineComponent({
  name: "HouseTree",
  components: {
    UfTreeNode
  },
  props: {
    data: {
      type: Array as PropType<HouseTreeNode[]>,
      required: true
    }
  },
  setup(props) {
    // 获取数据
    const { data } = toRefs(props);

    const multiple = inject<boolean>("multiple");

    const innerData = computed(() => data.value);
    // 默认展开的值
    const expandedKeys = reactive<string[]>([]);
    const updateExpandedKeys = (keys: string) => {
      const idx = expandedKeys.findIndex(_keys => _keys === keys);
      if (idx != -1) {
        expandedKeys.splice(idx, 1);
        return;
      }
      expandedKeys.push(keys);
      return;
    };
    provide("expandedKeys", readonly(expandedKeys));
    provide("updateExpandedKeys", updateExpandedKeys);
    // 选中的值
    const checked = reactive<HouseTreeNode | {}>({});
    // 多选的话
    const checkedList = reactive<HouseTreeNode[]>([]);

    const updateChecked = (data: HouseTreeNode) => {
      if (multiple) {
        const idx = checkedList.findIndex(checked => checked === data);
        if (idx != -1) {
          checkedList.splice(idx, 1);
          return;
        }
        checkedList.push(data);
        return;
      }
      Object.assign(checked, data);
    };
    provide("checked", readonly(checked));
    provide("checkedList", checkedList);

    provide("updateChecked", updateChecked);
    // 返回值
    const getCurrentNode = () => {
      if (multiple) {
        return checkedList;
      }
      return checked;
    };
    return {
      innerData,
      checked,
      checkedList,
      getCurrentNode,
      updateChecked
    };
  }
});
